import { jsx as _jsx } from "react/jsx-runtime";
import { useResource, Endpoint } from "@rest-hooks/core";
const readFile = new Endpoint(async function ({ file }) {
    return new Promise(resolve => {
        // even if we polyfill, on server we don't want to actually wait to resolve the File
        if (typeof window === "undefined" || typeof FileReader !== "function")
            resolve(undefined);
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result ?? undefined);
        };
        reader.onerror = error => {
            // in case we fail to load we actually don't want to error out but
            // let the browser display the normal image fallback
            resolve(reader.result ?? undefined);
        };
        reader.readAsDataURL(file);
    });
}, {
    key({ file }) {
        return `READ ${file.name}`;
    },
    schema: ""
});
export function FileImg(props) {
    const { file } = props;
    const src = useResource(readFile, { file });
    return _jsx("img", { ...props, alt: props.alt, src: src });
}
//# sourceMappingURL=FileImage.js.map